(function () {
  if (typeof window.VIP_VARIANT_ID === 'undefined' || typeof window.VIP_SELLING_PLAN_ID === 'undefined') {
    return;
  }

  window.avBuildVipCheckoutUrl = function (shirtItems) {
    var parts = shirtItems.split(',');
    var itemParams = '';
    var itemIndex = 0;

    parts.forEach(function (pair) {
      var seg = pair.split(':');
      var vid = seg[0];
      var qty = seg[1] || '1';
      itemParams += 'items[' + itemIndex + '][id]=' + vid + '&items[' + itemIndex + '][quantity]=' + qty + '&';
      itemIndex++;
    });

    itemParams += 'items[' + itemIndex + '][id]=' + window.VIP_VARIANT_ID;
    itemParams += '&items[' + itemIndex + '][quantity]=1';
    itemParams += '&items[' + itemIndex + '][selling_plan]=' + window.VIP_SELLING_PLAN_ID;
    itemParams += '&return_to=/checkout';
    return '/cart/add?' + itemParams;
  };
})();
